import { vdkHappinessPortalApi } from "./vdk-happiness-portal-api";
const GetAll = () => {
    return vdkHappinessPortalApi.get(`dietaryOptions/get-options`);
};
const DietaryApi = {
    GetAll,
};
export default DietaryApi;
